import ACM from './acm-browser';

ACM.updateRegister();



// WEBPACK FOOTER //
// ./src/update-browser.js